import { useEffect, useRef, useState } from "react";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import CTLTable from "application/components/CTLTable";
import { getColumns, Attributes, operationURLS } from "./model";
import CTLAdvancedFilter from "application/components/CTLAdvancedFilter";
import { application } from "globals/endpoints";
import CTLBaseDialogForm from "application/components/CTLBaseDialogForm";
import CTLNotification from "application/components/CTLNotification";
import { getMultiUpdateColumns } from "./model/MultiUpdate";

function SiteConfigurationMenu({
  onLoad,
  pageId,
  searchText,
  registerCallBacks,
  pageName,
}) {
  const [controller, dispatch] = useMaterialUIController();
  const { activePage } = controller;
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [advancedFilters, setAdvancedFilters] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [formData, setFormData] = useState({});
  const [updateList, setUpdateList] = useState(Date.now());
  const [multiUpdate, setMultiUpdate] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });
  useEffect(() => {
    Attributes && onLoad(Attributes);
    registerCallBacks &&
      registerCallBacks({
        openAdvancedFilter: onOpenFilter,
        openForm: onOpenForm,
        MultipleUpdate: onOpenMultiUpdate,
      });
  }, [activePage]);
  const selectedRowsRef = useRef([]);
  const selectedRowActiveRef = useRef([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  useEffect(() => {
    const Id = selectedRowData.map((item) => item.id);
    selectedRowsRef.current = Id;

    const Active = selectedRowData.map((item) => item.isActive);
    selectedRowActiveRef.current = Active;
  }, [selectedRowData]);

  function onOpenMultiUpdate() {
    if (!selectedRowsRef.current || selectedRowsRef.current.length === 0) {
      setNotify({
        isOpen: true,
        status: "Please select at least one row",
        type: "warning",
        pagename: "Site Configuration Menu",
      });
      return;
    }
    setMultiUpdate(true);
  }

  function onRowSelectionChange(row) {
    setSelectedRowData(row);
  }

  function onOpenFilter() {
    setOpenFilter(true);
  }

  function onOpenForm() {
    setFormData({
      eventTime: Date.now(),
    });
    setOpenForm(true);
  }

  function onCloseFilter() {
    setOpenFilter(false);
  }

  function onApplyFilter(advancedFilters) {
    setAdvancedFilters(advancedFilters);
    setOpenFilter(false);
  }

  const editRow = (row) => {
    if (selectedRowsRef.current && selectedRowsRef.current.length > 0) {
      setNotify({
        isOpen: true,
        status: "You have selected rows for multi-update. Single update is disabled.",
        type: "warning",
        pagename: "Site Configuration Menu",
      });
      return;
    }
    setFormData(row);
    setOpenForm(true);
  };
  

  const deleteRow = (row) => {
    setSelectedRow(row);
    setConfirmDelete(true);
  };

  function onSaveForm(data) {
    let updateData = {
      ...data,
      id: [data.id],
    };
    if (data.id) {
      application
        .post(operationURLS.update, updateData)
        .then((response) => {
            setNotify({
              isOpen: true,
              status:`${response.data.messageDetail}. You need to Re-Login to get change Effect.`,
              type: "success",
              pagename: "Site Configuration Menu",
            });
          setUpdateList(Date.now());
        })
        .catch((error) => {
          setNotify({
            isOpen: true,
            status:
              error.response?.data?.message +
              " " +
              error.response?.data?.messageDetail,
            type: "error",
            pagename: "Site Configuration Menu",
          });
        });
    }
    setOpenForm(false);
  }

  function MultiUpdate(data) {
    let updateData = {
      id: selectedRowsRef.current,
      isActive: data.isActive ?? false,
    };
    application
      .post(operationURLS.update, updateData)
      .then((response) => {
        setNotify({
          isOpen: true,
          status: `${response.data.messageDetail},You need to Re-Login to get change Effect`,
          type: "success",
          pagename: "Site Configuration Menu",
        });
        setUpdateList(Date.now());
        setMultiUpdate(false);
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          status:
            error.response?.data?.message +
            " " +
            error.response?.data?.messageDetail,
          type: "error",
          pagename: "Site Configuration Menu",
        });
      });
  }

  function onCloseForm() {
    setOpenForm(false);
  }

  function onCloseMultiUpdate() {
    setMultiUpdate(false);
  }

  return (
    <MDBox>
      <CTLBaseDialogForm
        entityName="Site Configuration"
        columns={getColumns(deleteRow, editRow)}
        openForm={openForm}
        onSaveForm={onSaveForm}
        onCloseForm={onCloseForm}
        formData={formData}
        pageAttributes={Attributes}
      />

      {multiUpdate && (
        <CTLBaseDialogForm
          entityName="Site Configuration MultiUpdate"
          columns={getMultiUpdateColumns()}
          openForm={multiUpdate}
          onSaveForm={MultiUpdate}
          onCloseForm={onCloseMultiUpdate}
          formData={formData}
          pageAttributes={Attributes}
        />
      )}
      <CTLTable
        apiURL={operationURLS.list}
        onRowSelectionChange={onRowSelectionChange}
        advancedFilters={advancedFilters}
        columns={getColumns(deleteRow, editRow)}
        entriesPerPage={false}
        canSearch
        defaultSortDirection="asc"
        defaultSortColumn="id"
        pageId={pageId}
        list
        searchText={searchText}
        hasRowSelection={true}
        updateList={updateList}
        disablePagination={false}
      />
      <CTLAdvancedFilter
        entityName="Site Configuration"
        columns={getColumns(deleteRow, editRow)}
        applyFilter={openFilter}
        onApplyFilter={onApplyFilter}
        onCloseFilter={onCloseFilter}
        advancedFilters={advancedFilters}
      />
      <CTLNotification notify={notify} setNotify={setNotify} />
    </MDBox>
  );
}

export default SiteConfigurationMenu;
